import classes from "../CountrySelect.module.scss";
import { ReactComponent as GeoIcon } from "../../../assets/icons/geo.svg";
import { ReactComponent as GeoGryIcon } from "../../../assets/icons/geo-grey.svg";
import { ValueContainerProps } from "react-select";

const ValueContainer = ({ children, selectProps }: ValueContainerProps<any, boolean>) => (
  <div className={classes.selectValueContainer}>
    <div className={classes.selectGeoIcon}>
      { selectProps.menuIsOpen && <GeoIcon/> }
      { !selectProps.menuIsOpen && <GeoGryIcon/> }
    </div>
    { children }
  </div>
);

export default ValueContainer;